import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {LoginComponent} from './login/login.component';
import {DashboardModule} from './dashboard/index.module';
import {AppRoutingModule} from './app-routing.module';
import {environment} from '../environments/environment';
import {JwtModule} from '@auth0/angular-jwt';
import {HttpClientModule} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {StoreModule, ActionReducer, MetaReducer} from '@ngrx/store';
import {reducerProvider, reducerToken, effects, LOGOUT_USER} from './store';
import {CustomSerializer} from './store/reducers/router.reducer';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {EffectsModule} from '@ngrx/effects';
import {RouterStateSerializer, StoreRouterConnectingModule} from '@ngrx/router-store';
import {CoreModule} from './shared/core/core.module';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';


export const metaReducers: MetaReducer<any>[] = [rootReducer];

export function rootReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    switch (action.type) {
      case LOGOUT_USER:
        state = undefined;
    }
    return reducer(state, action);
  };
}


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent
  ],
  imports: [
    AppRoutingModule,
    CoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    StoreModule.forRoot(reducerToken, {metaReducers}),
    EffectsModule.forRoot(effects),
    LoadingBarHttpClientModule,
    StoreRouterConnectingModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: environment.whitelistedDomains
      }
    })
  ],
  providers: [{
    provide: RouterStateSerializer,
    useClass: CustomSerializer
  }, reducerProvider],
  bootstrap: [AppComponent]
})
export class AppModule {
}

export function tokenGetter() {
  return localStorage.getItem('token');
}




// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/app.module.ts